import { supabaseClient } from './supabase';
import { cacheManager } from './cache/cacheManager';
import { SUPABASE_TABLES } from './supabase/tables';
import { logger } from './logger';
import type { RGPDConfig, PrivacyPolicy } from '../types/rgpd';

class RGPDClient {
  private static instance: RGPDClient;

  private constructor() {}

  public static getInstance(): RGPDClient {
    if (!RGPDClient.instance) {
      RGPDClient.instance = new RGPDClient();
    }
    return RGPDClient.instance;
  }

  public async getConfig(): Promise<RGPDConfig[]> {
    try {
      const { data, error } = await supabaseClient
        .from(SUPABASE_TABLES.RGPD.name)
        .select('*')
        .order('key');

      if (error) {
        throw error;
      }

      return data;

    } catch (error) {
      logger.error('Error loading RGPD config', {
        category: 'RGPD',
        data: { error }
      });
      throw error;
    }
  }

  public async getPrivacyPolicy(): Promise<PrivacyPolicy[]> {
    const cacheKey = 'privacy_policy';
    const cached = cacheManager.get<PrivacyPolicy[]>(cacheKey);
    
    if (cached) {
      return cached;
    }

    try {
      const { data, error } = await supabaseClient
        .from(SUPABASE_TABLES.PRIVACY_POLICY.name)
        .select('*')
        .order('order');

      if (error) {
        throw error;
      }

      // Cache for 5 minutes
      cacheManager.set(cacheKey, data, 5 * 60 * 1000);

      return data;

    } catch (error) {
      logger.error('Error loading privacy policy', {
        category: 'RGPD',
        data: { error }
      });
      throw error;
    }
  }
}

export const rgpdClient = RGPDClient.getInstance();

// Service wrapper for easier usage
export const rgpdService = {
  async getConfig() {
    return rgpdClient.getConfig();
  },

  async getPrivacyPolicy() {
    return rgpdClient.getPrivacyPolicy();
  }
};